import React, { createRef, useState, useEffect, Suspense, lazy, useRef } from "react";
import {mmt} from './memorandumTemplate';
import {annext} from './annexTemplate';
import {signalt} from './signalTemplate';
import {vstf} from './visitorsForm';
import {directedl} from './directedTemplate';
import {formal} from './formalTemplate';
import {routinecivil} from './routineCivilTemplate';
import {routine} from './routineTemplate';
import {
    Button,
    Row,
    Col,
    Checkbox,
    Avatar,
    Tooltip
} from "antd";

import ReactQuill, { Quill } from "react-quill-with-table";
import './CommonEditor.css';
import "react-quill/dist/quill.snow.css";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import socketIOClient from "socket.io-client";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from "react-router-dom";
import { CloudUploadOutlined, SyncOutlined, UserOutlined, AntDesignOutlined } from '@ant-design/icons';
import { commonDocumentSelector, clearState, getUsersNameAsyn, clearAllUsersNameState, ShareDocWithUsersAsyn, saveDraftName, sharedUserInfo, clearStateclearOnlyDataSuccess } from './CommonDocumentSlice';
import Container from "../Layout/Container";
// import ShareWithUsersList from "./ShareWithUsersList";
import { authSelector } from '../Auth/authSlice';
// import SharedDocUserList from "./SharedDocUserList";
import ImageResize from 'quill-image-resize-module-react';

import QuillBetterTable from "quill-better-table";
// import QuillBetterTable from 'quill-image-resize-module-react';
import BlotFormatter, { AlignAction, DeleteAction, ImageSpec } from "quill-blot-formatter";
import { lmt } from "./looseminuteTemplate";
import { ToolBar } from "@antv/g6-pc";
import "react-quill-with-table/dist/quill.snow.css";
import "react-quill-with-table/dist/quill.bubble.css";
import 'react-quill/dist/quill.snow.css'; 
import * as QuillTableUI from 'quill-table-ui'

Quill.register({
  'modules/tableUI': QuillTableUI.default
}, true);

Quill.register({
    'modules/better-table': QuillBetterTable
  }, true)





const CheckboxGroup = Checkbox.Group;
var mainRef = createRef();
var socketio = socketIOClient(process.env.REACT_APP_SOCKET_URL, { transports: ['websocket'] });
const ShareWithUsersList = lazy(() => import('./ShareWithUsersList'));
const SharedDocUserList = lazy(() => import('./SharedDocUserList'));

Quill.register('modules/imageResize', ImageResize);


  
Quill.register('modules/blotFormatter', BlotFormatter);

var Font = Quill.import('formats/font');
Font.whitelist = ["arial", "tnr", "monospace", "cursive", "fantasy", "sans-serif", "serif", "FreeMono"];
Quill.register(Font, true);






class CustomImageSpec extends ImageSpec {
    getActions() {
        return [AlignAction, DeleteAction];
    }
}

const CommonEditor = () => {
   

    const dispatch = useDispatch();
    const location = useLocation();
    const [viewallUserData, setDataSource] = React.useState([]);
    const [MsgSveStatus, setMsgSveStatus] = React.useState('');
    const [UpdateIcon, setUpdateIcon] = React.useState(null);
    const [UsersOnlineData, setUsersOnlineData] = React.useState([]);
    const inputEl = useRef(null);
   

    const { isFetching, isError, errorMessage, isUsersNameSuccess, allUserNames, sharedUserInfoData, isSharedUserInfoSucess, checkOwner } = useSelector(
        commonDocumentSelector
    );

    const { user } = useSelector(
        authSelector
    );

    useEffect(() => {
        let alreadyConnect = false;

        socketio.on('connect', function () {

            alreadyConnect = true;
            // console.log('text editor socket connected => ', socketio);
        });

        if (!alreadyConnect) { socketio.connect(); }

        dispatch(clearState());
        dispatch(sharedUserInfo(location.state.roomId));
        // if (checkOwner === user.username) { dispatch(getUsersNameAsyn(`${location.state.roomId}&page=1`)); }
        // setTimeout(async () => {
        // let abc = dispatch(getUsersNameAsyn(`${location.state.roomId}&page=1`));
        // console.log("abc", abc);
        // }, 100)

        const sleep = m => new Promise(r => setTimeout(r, m));

        async function test() {
            // console.time("Slept for")
            // console.log('3 sec done')
            await sleep(100)
            try {
                let a = await dispatch(getUsersNameAsyn(`${location.state.roomId}&page=1`));
                // console.log(a)
            } catch (error) {
                // console.log(error)
            }
            // console.timeEnd("Slept for")
        }

        test();


    }, []);

    useEffect(() => {

        if (isSharedUserInfoSucess) {

            setDataSource(sharedUserInfoData)

            let sendData = {
                userName: user.username,
                fullName: user.fullName,
                id: location.state.roomId,
            }

            socketio.emit("joinRoom", sendData);

            if (sharedUserInfoData && sharedUserInfoData.data) {

                if (inputEl.current !== null) inputEl.current.value = sharedUserInfoData.data.docName ? sharedUserInfoData.data.docName : '';
                const delta = mainRef.current.getEditor().clipboard.convert(sharedUserInfoData.data.html)
                mainRef.current.getEditor().setContents(delta, 'silent');
                setWriter(sharedUserInfoData.data.html);
                // console.log(sharedUserInfoData.data.html)
            }
            dispatch(clearStateclearOnlyDataSuccess());
        }

    }, [isError, isSharedUserInfoSucess, sharedUserInfoData, socketio]);


    useEffect(() => {


        socketio.on(`${location.state.roomId}_ba_changes`, function (Fdata) {


            // console.log("FData data => ", Fdata)

            if (mainRef.current !== null) {
                const delta = mainRef.current.getEditor().clipboard.convert(Fdata.data)

                mainRef.current.getEditor().setContents(delta, 'silent')
                // mainRef.current.getEditor().root.innerHTML = '<p>hell</p>';
            }

        })


        socketio.on(`${location.state.roomId}_ba_activeUsers`, function (Udata) {
            setUsersOnlineData(Udata)
            // console.log("UData data => ", Udata)
        })



    }, [socketio, sharedUserInfoData])


    useEffect(() => {
        return () => {

            let data = {
                id: location.state.roomId, userName: user.fullName,
            }
            socketio.emit("leaveRoom", data);
            socketio.disconnect();
            // console.log("socket close => ", socketio);
        }
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            socketio.emit('activeUsers', location.state.roomId)
        }, 5000);
        return () => clearInterval(interval);
    }, []);



    const modules = {

       table: true,
       tableUI:true,
     
    // "better-table": {
    //     operationMenu: {
    //       items: {
    //         unmergeCells: {
    //           text: "Another unmerge cells name"
    //         }
    //       }
    //     }
    //   },
        
       
        // keyboard: {
        //   bindings: QuillBetterTable.keyboardBindings
        // },
      
    
        toolbar: [
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ font: Font.whitelist }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link", "image", "video"],
           
            ["code-block"],
            [{ direction: "rtl" }],
            ["formula"],
            // [{ size: ["small", false, "large", "huge"] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ script: "sub" }, { script: "super" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            // [{ font: [] }],
            // [{ redo: 'redo' }, { undo: 'undo' }],
            ["clean"],
        ],
        // handlers: {
        //     redo() { this.quill.history.redo(); },
        //     undo() { this.quill.history.undo(); }
        // },
        // history: {
        //     delay: 2000,
        //     maxStack: 500,
        //     userOnly: true
        // },
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: true
        },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        },

 
        // blotFormatter: {
        //     // specs: [ for get the value of image ..
        //     //     CustomImageSpec,
        //     // ],
        //     overlay: {
        //         style: {
        //             border: '2px solid red',
        //         }
        //     }
        // }



    };

    const getValue = (content, delta, source, editor) => {
    };

    let saveMango = true;
    // var epoch = Date.now();
    // var datetime = new Date(epoch);
    // var hour = datetime.getHours();
    // var minute = datetime.getMinutes();
    // var second = datetime.getSeconds();

    const pleaseClickMe = () => {
         
        // setWriter(e.target.value);
        setMsgSveStatus('Saving...');
        setUpdateIcon(<SyncOutlined spin />);
        // console.log("click");
        let data = {
            "roomId": location.state.roomId,
            "data": mainRef.current.getEditor().root.innerHTML,
        }
        socketio.emit(`fa_changes`, data);

        if (saveMango) {
            saveMango = false;
            setTimeout(() => {

                setUpdateIcon(<CloudUploadOutlined />);
                // setMsgSveStatus('Saved at ' + hour + ":" + minute + ":" + second);
                setMsgSveStatus('Saved at ' + new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
                saveMango = true;
                let data = {
                    "roomId": location.state.roomId,
                    // "data": mainRef.current !== null ? mainRef.current.getEditor().root.innerHTML : '',
                    "data": mainRef.current !== null ? mainRef.current.getEditor().root.innerHTML : '',
                    "save": true,
                }
                console.log(mainRef.current.getEditor().root.innerHTML, 'the value')
                socketio.emit(`fa_changes`, data);
            }, 2500);
        }

        // setTimeout(() => {
        //     setMsgSveStatus('');
        // }, 5000);

    }


    const SaveDocData = () => {
        // console.log("saved data");
        let data = {
            "roomId": location.state.roomId,
            "data": mainRef.current.getEditor().root.innerHTML,
            "save": true,
        }
        socketio.emit(`fa_changes`, data);
        setUpdateIcon(<CloudUploadOutlined />);
        // setMsgSveStatus('Saved at ' + hour + ":" + minute + ":" + second);
        setMsgSveStatus('Saved at ' + new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
    }

    const DownloadDocData = (e) => {
        e.preventDefault();
        // window.print();
      
       var htmlToPrint = '' +
       '<style type="text/css">' +
       ' body {'+
       'font-size:14px' +
       'font-family: arial, sans-serif;' +
       'width:100%' +
       '}' +
       
       
       '.ql-align-center {'+
       'text-align: center;' +
       'font-family: arial, sans-serif;' +
       '}' +
       '.ext{'+
      
       'margin-top:-90px' +
       '}' +
       'h4.ql-align-center {'+
      'margin-left:72% !important;' +
       'text-decoration: underline;' +
       'height:10;' +
       'width:95% !important;' +
       'display: flex;' +
       
       '}' +
     

       'h3.ql-align-center {'+
       'margin-left:72% !important;' +
       
       'height:10;' +
       'width:95% !important;' +
       'display: flex;' +

       '}' +
       'p .tm {' +
       'text-align: center;' +
       'font-family: arial, sans-serif;' +
       '}' +
       'table {' +
       'font-family: arial, sans-serif;' +
       'border-collapse: collapse;' +
       'width:95%' +
       '}' +
       'table th, table td {' +
       'border:1px solid #000;' +
       'padding:0.5em;' +
       '}' +
       '</style>';

        var mywindow = window.open('', 'childWindow',  'status=1, location=yes, menubar=yes, toolbar=yes, height=400,width=600');

        // mywindow.document.write('<html><head><title>' + document.title + '</title>');
        // mywindow.document.write('</head><body >');
        // mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(`${htmlToPrint} ${mainRef.current.getEditorContents()}`);
        // mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        setTimeout(function(){  mywindow.print(); mywindow.close();}, 2000);

       
        // mywindow.close();

        return true;


        // const elemntData = document.getElementById('quillmain');
        // const elemntData = document.getElementsByClassName('ql-editor');
        // const elemntData = mainRef.current.getEditor().root.innerHTML;
        // var parser = new DOMParser();
        // var doc = parser.parseFromString(elemntData, 'text/html');


        // console.log("doc", doc.body);
        // // useThisRef.current.removeChild()
        // useThisRef.current.appendChild(doc.body);
        // var doc = new jsPDF()

        // doc.addPage();
        // doc.addImage(elemntData, "JPEG", 0, 0);
        // doc.output("dataurlnewwindow");


        // html2canvas(elemntData).then((canvas) => {
        //     const imgData = canvas.toDataURL("image/png");
        //     const pdf = new jsPDF();
        //     var width = pdf.internal.pageSize.getWidth() - 10;
        //     var height = pdf.internal.pageSize.getHeight() - 10;

        //     pdf.addImage(imgData, "PNG", 30, 20);
        //     // pdf.text(values.title, 20, 10);

        //     // pdf.addImage(imgData, "PNG", 30, 20);
        //     // pdf.text(values.title, 20, 10);
        //     // var a = pdf.save("download.pdf");
        //     // var blob = pdf.output("blob");
        //     pdf.save("download.pdf");

        // });


    }

    function getRandomColor(name) {

        if (name) {

            // get first alphabet in upper case
            const firstAlphabet = name.charAt(0).toLowerCase();

            // get the ASCII code of the character
            const asciiCode = firstAlphabet.charCodeAt(0);

            // number that contains 3 times ASCII value of character -- unique for every alphabet
            const colorNum = asciiCode.toString() + asciiCode.toString() + asciiCode.toString();

            var num = Math.round(0xffffff * parseInt(colorNum));
            var r = num >> 16 & 255;
            var g = num >> 8 & 255;
            var b = num & 255;

            return {
                color: 'rgb(' + r + ', ' + g + ', ' + b + ', 9.9)',
                character: firstAlphabet.toUpperCase()
            };
        }
    }

    const displayAllOnlineUsers = () => {

        // let profileArray = ['msg', 'ashu', 'kman', 'ramu', 'raj gupta', 'd', 'e', 'l', 'f', 'k', 'o', 'z'];
        // let profileArray = sharedUserInfoData && sharedUserInfoData.data && sharedUserInfoData.data.users ? sharedUserInfoData.data.users : [];
        let profileArray = UsersOnlineData ? UsersOnlineData : [];
        return <Avatar.Group
            maxCount={5}
            maxStyle={{
                color: '#f56a00',
                backgroundColor: '#fde3cf',
            }}
        >
            {profileArray.map((data, key) => {
                // let code = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
                // let code2 = getRandomColor(data).color;
                // console.log("code => ", code2);

                return (
                    <Tooltip title={data} placement="top">
                        <Avatar
                            style={{
                                backgroundColor: getRandomColor(data).color,
                            }}
                            key={key}
                        >
                            {/* {data.charAt(0).toUpperCase()} */}
                            {getRandomColor(data).character}
                        </Avatar>
                    </Tooltip>
                );
            })}

        </Avatar.Group>
    };



    const getSaveDraftName = (d_name) => {

        let data = {
            roomId: location.state.roomId,
            docName: inputEl.current.value
        };
        dispatch(saveDraftName(data));

    }
   
    // goBack = () => {
    //     this.props.history.goBack();
    //   };
    //History
const history = useHistory();

  
    let [writer, setWriter] = useState("");
   
    const memp = (e) => {
        const memo = e.target.value;
        //  console.log(e.target.value);
        // mainRef.current.getEditor().root.innerHTML
     
        {memo=="memorandum" ? setWriter(mmt): 
        memo=="signal" ? setWriter(signalt):
        memo=="looseminute" ? setWriter(lmt):
        memo=="annex" ? setWriter(annext):
        memo=="visitorsform" ? setWriter(vstf):
        memo=="directedl" ? setWriter(directedl):
        memo=="routinecivil" ? setWriter(routinecivil):
        memo=="formal" ? setWriter(formal):
        memo=="routine" ? setWriter(routine):
        setWriter(``)}
        // {memo=="signal" ? setWriter(signalt): setWriter(``)}
    
    }


    useEffect(() => {
        
         const editon = mainRef.current.getEditor();
        let tableModule = editon.getModule("table");
        // console.log(tableModule);
        
        document.body.querySelector('#insert-table')
        .onclick = () => {
      
        tableModule.insertTable(3, 3)
        }
    
      
      }, []);
   
        // const editon = mainRef.current.getEditor();
        //console.log(editon.getModule("toolbar"));
        // let tableModule = editon.getModule("better-table");
       
       


    // let mainRef = useRef()
    // useEffect(() => {
      
    //     // const editon = mainRef.current.getContents();
    //     // console.log(editon.getModule("toolbar"));
    //     // let tableModule = editon.getModule("better-table");
    //     document.body.querySelector('#insert-table')
    //     .onclick = () => {
    //       QuillBetterTable.insertTable(3, 3)
    //     }
    //   }, []);
   
    
   

    return (
        <>
            <>
                <Container >
                    <Row gutter={0} style={{ padding: 20 }}>
                        <Col span={24}>
                            <div className="all-on-line-users" style={{ marginBottom: '15px' }}>{displayAllOnlineUsers()}</div>
                        </Col>
                        <Col span={18} style={{ paddingRight: '20px' }}>
                            <div style={{ border: "1px solid #e3e5ee", borderRadius: '5px', backgroundColor: '#ffffff', padding: '15px' }} className="clerk-dashboard-tab-sec">
                                <div className="" >
                                    {checkOwner === user.username ? <div style={{ display: 'flex', justifyContent: 'space-around' }}><input onBlur={getSaveDraftName} placeholder="Document Name" ref={inputEl} type="text" className="ant-input-affix-wrapper" style={{ marginBottom: '10px', maxWidth: '300px' }} />

<select  onChange={memp}>
<option selected value="">SELECT TEMPLATE</option>
  {/* <option value="annex">ANNEX</option>
  <option value="looseminute">LOOSE MINUTE</option>
  <option value="directedl">DIRECTED LETTER</option>
  <option value="formal">FORMAL LETTER</option>
  <option value="routine">ROUTINE LETTER</option>
  <option value="routinecivil">ROUTINE LETTER CIVIL ORG.</option> */}

  <option value="visitorsform">VISITOR'S FORM</option>
 
  {/* <option value="memorandum">MEMORANDUM</option> */}
  {/* <option value="signal">SIGNAL</option> */}
</select>
</div>
                                        : <h2 className="doc-saved-nametitle">{sharedUserInfoData && sharedUserInfoData.data && sharedUserInfoData.data.docName}</h2>}
                                    <h2 className="doc-saved-time">{UpdateIcon}{" "}{MsgSveStatus}</h2>


                                </div><div>
                                    
                                    {/* <input placeholder="Dropdown" type="text" className="ant-input-affix-wrapper" style={{ marginBottom: '10px', maxWidth: '300px' }}  /> */}
       
                                    {/* <label for="cars">Choose Document Template:</label> */}



                                </div>
                                <div className="ui container">
                                {/* <button id="insert-table">Insert table</button> */}
                                <button class="uitablecss" id="insert-table">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M21 12H3M12 3v18"/></svg>
                                </button>
                                    <ReactQuill
                                    name="rquill"
                                        // onFocus={pleaseClickMe}
                                        // onKeyDown={pleaseClickMe}
                                        // onChangeSelection={pleaseClickMe}
                                        // onClick={pleaseClickMe}
                                        value={writer}
                                        
                                            onChange={setWriter}
                                      
                                        onKeyPress={pleaseClickMe}
                                        // onMouseUp={pleaseClickMe}
                                         
                                        
                                      
                                        id="quillmain"
                                        className="document-share-quill-editor"
                                        modules={modules}
                                        placeholder="Write from here..."
                                        theme="snow"
                                        
                                        ref={mainRef}
                                    />
                                </div>
                                <div style={{ textAlign: 'right', marginTop: '15px', display: 'flex', justifyContent: 'space-between' }}>
                                <Button type="primary" onClick={() => history.goBack()} >Go Back</Button>
                                    <Button type="primary" onClick={(e) => DownloadDocData(e)} >Now Print / Download</Button>
                                    <Button type="primary" onClick={(e) => SaveDocData(e)} >Save</Button>
                                   
                                    {/* <Col span="16">
              <Button onClick={this.history.back()} type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
                Back
              </Button>
            </Col> */}
                                
                                </div>
                                
                            </div>
                        </Col>

                        <Col span={6}>
                            <Suspense fallback={<div>Loading .....</div>}>
                                {checkOwner === user.username ? <ShareWithUsersList /> : <SharedDocUserList />}
                            </Suspense>
                        </Col>
                    </Row>
                </Container>
            </>
        </>
    );
};

export default CommonEditor;